(() => {
  class RecipeSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('[data-recipe-search-input]');
      this.clearButton = this.querySelector('[data-recipe-search-clear]');
      this.resultsContainer = this.querySelector('[data-recipe-search-results]');
      this.noResultsContainer = this.querySelector('[data-recipe-search-no-results]');
      this.blogUrl = this.getAttribute('data-blog-url') || '';
      this.searchTimer = null;
      this.abortController = null;
    }

    connectedCallback() {
      window.wetheme.webcomponentRegistry.register({ key: 'component-recipe-search' });
      this.input.addEventListener('input', this.onInput.bind(this));
      this.clearButton.addEventListener('click', this.onClear.bind(this));
    }

    get blogSection() {
      return document.querySelector('.shopify-section:has(.template-blog)');
    }

    onInput() {
      clearTimeout(this.searchTimer);
      const query = this.input.value.trim();

      this.clearButton.classList.toggle('hide', query === '');

      if (query.length < 2) {
        this.resetResults();
        return;
      }

      this.searchTimer = setTimeout(() => this.performSearch(query), 300);
    }

    async performSearch(query) {
      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();

      const url = `${window.Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=article&resources[limit]=12`;

      try {
        const response = await fetch(url, { signal: this.abortController.signal });
        if (!response.ok) return;
        const data = await response.json();

        let articles = data.resources?.results?.articles || [];

        // Filter to current blog only
        if (this.blogUrl) {
          articles = articles.filter(a => a.url.startsWith(this.blogUrl));
        }

        if (articles.length === 0) {
          this.resultsContainer.hidden = true;
          this.resultsContainer.innerHTML = '';
          this.noResultsContainer.hidden = false;
          this.toggleBlogGrid(false);
          return;
        }

        this.noResultsContainer.hidden = true;
        this.resultsContainer.hidden = false;
        this.resultsContainer.innerHTML = this.renderResults(articles);
        this.toggleBlogGrid(false);
      } catch (e) {
        if (e.name !== 'AbortError') console.error('Recipe search failed:', e);
      }
    }

    renderResults(articles) {
      return `<div class="recipe-search__grid">
        ${articles.map(article => `
          <a href="${article.url}" class="recipe-search__result">
            ${article.image ? `<div class="recipe-search__result-image">
              <img src="${article.image}" alt="${this.escapeHtml(article.title)}" loading="lazy">
            </div>` : ''}
            <div class="recipe-search__result-content">
              <h3 class="recipe-search__result-title">${this.escapeHtml(article.title)}</h3>
              ${article.body ? (() => { const clean = this.stripHtml(article.body).trim(); return clean ? `<p class="recipe-search__result-excerpt">${this.escapeHtml(clean.substring(0, 120))}${clean.length > 120 ? '...' : ''}</p>` : ''; })() : ''}
            </div>
          </a>
        `).join('')}
      </div>`;
    }

    escapeHtml(str) {
      const div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    stripHtml(str) {
      const div = document.createElement('div');
      div.innerHTML = str;
      return div.textContent || div.innerText || '';
    }

    toggleBlogGrid(show) {
      const blogSection = this.blogSection;
      if (blogSection) {
        blogSection.style.display = show ? '' : 'none';
      }
    }

    onClear() {
      this.input.value = '';
      this.clearButton.classList.add('hide');
      this.resetResults();
      this.input.focus();
    }

    resetResults() {
      this.resultsContainer.hidden = true;
      this.noResultsContainer.hidden = true;
      this.resultsContainer.innerHTML = '';
      this.toggleBlogGrid(true);
    }

    disconnectedCallback() {
      clearTimeout(this.searchTimer);
      if (this.abortController) this.abortController.abort();
    }
  }

  customElements.define('recipe-search', RecipeSearch);
})();
